import React, { Component } from 'react';
import { connect } from 'react-redux';
import { API } from 'aws-amplify';
import { Button, Form, Input, Layout, Row, Col, Spin } from 'antd';
import { LeftOutlined, TableOutlined } from '@ant-design/icons';

const { Header, Content } = Layout;
const ButtonGroup = Button.Group;


class Edit extends Component {
    state = {
        loading: false,
        unit: [],
        itemName: '',
        pcid: null
    }

    loadData() {
        this.setState({loading: true});
        this.setState({pcid: this.props.cid});
        const id = this.props.match.params.id;

        API.get('benackoAPI', '/items/' + id)
            .then(response => {
                const name = response[0].name;

                this.setState({itemName: name});
            })
            .catch(error => console.log(error))
            .finally(() => this.setState({loading: false}));
    }

    componentDidMount() {
        this.loadData();
    }

    editTypeHandler = () => {
        this.setState({loading: true});

        const id = this.props.match.params.id;
        const beautifiedName = this.state.itemName.trim().toLowerCase();

        API.put('benackoAPI', '/items/' + id, {
                body: {
                    name: beautifiedName
                }
            })
            .then( () => {
                this.setState({loading: false});
                this.props.history.goBack();
            })
            .catch( error => {
                console.log(error);
                this.setState({loading: false});
            });
    }

    goBackHandler = () => {
        this.props.history.goBack();
    }

    render() {
        return(
            <Layout>
                <Header style={{width: '100%', background: '#fff', padding: 0, paddingLeft: 20}}>
                    <Row>
                        <ButtonGroup>
                            <Button type="primary" onClick={this.goBackHandler}>
                                <LeftOutlined />Regresar
                            </Button>
                        </ButtonGroup>
                    </Row>
                </Header>
                <Content style={{ margin: 0, padding: 0, background: '#ffff' }}>
                    <Spin spinning={this.state.loading} size="large">
                        <Form className="login-form">
                            <Row style={{marginTop: 10}}>
                                <Col span={20} offset={2}>
                                    <p>Nombre:</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={20} offset={2}>
                                    <Input style={{width: '100%'}} onChange={(e) => this.setState({itemName: e.target.value})} prefix={<TableOutlined style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Nombre" />
                                </Col>
                            </Row>
                            <Row style={{marginTop: 20}}>
                                <Col span={4} offset={2}>
                                    <Button type="primary" 
                                        onClick={this.editTypeHandler}
                                        disabled={this.state.itemName == null || this.state.itemName <= 1} className="login-form-button"
                                    >
                                        Editar
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </Content>
            </Layout>
        );
    }
}

const mapStateToProps = state => {
    return {
        cid: state.base.cid
    };
};

export default connect(mapStateToProps, null)(Edit);